import { useEffect, useState } from 'react'

/**
 * A clock for render (lane BOO1): the time the component mounted, then every `ms` while `on`. Render reads this
 * instead of `Date.now()`, which is impure and which the React Compiler would memoize with the rest of the render:
 * "3 min ago", "muted", "expired" stay as fresh as the clock. Turned on later, it reads the time again at once (a
 * clock read within the last half second is kept, so mounting costs no second render).
 */
export function useNow(ms = 60_000, on = true): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!on) return
    const first = setTimeout(() => setNow((prev) => (Date.now() - prev > 500 ? Date.now() : prev)), 0)
    const t = setInterval(() => setNow(Date.now()), ms)
    return () => {
      clearTimeout(first)
      clearInterval(t)
    }
  }, [ms, on])
  return now
}
